/**
 * isLocalhost - true when running against the local dev server.
 *
 * Lives at the app level because its consumers span layers: the shared insight-polling hook
 * (components/utils) plus the Agenda and Action Items session features. A feature-level home would
 * force the app-level hook to import downward into a feature, inverting the dependency direction.
 *
 * Guards on `typeof window` so it is safe to call outside a browser context (SSR, tests, tooling).
 *
 * Matches on prefix rather than exact equality, so it holds for any path under the dev origin and
 * not just the root. Note the rest of the app uses other spellings of this check
 * (`=== "http://localhost:3000/"`, `.includes("http://localhost:3000/")`); those are root-path-only
 * and are NOT interchangeable with this one, so they are deliberately left alone.
 */
export const isLocalhost = () =>
  typeof window !== "undefined" && window.location.href.startsWith("http://localhost:3000");
